import { Component, OnInit, ViewChild, ViewContainerRef, ComponentRef, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InsuranceVariantService } from '../../shared/services/insurance-variant.service';
import { Loader } from '../../shared/loader/loader';

@Component({
  selector: 'app-details-me-wrapper',
  standalone: true,
  imports: [CommonModule, Loader],
  template: `
    <app-loader *ngIf="isLoading" [fullscreen]="true" [message]="'Loading...'"></app-loader>
    <ng-container #variantContainer></ng-container>
  `,
  styles: []
})
export class DetailsMEWrapper implements OnInit {
  @ViewChild('variantContainer', { read: ViewContainerRef, static: true })
  variantContainer!: ViewContainerRef;

  isLoading = true;
  private componentRef: ComponentRef<any> | null = null;

  constructor(
    private insuranceVariantService: InsuranceVariantService
  ) {}

  ngOnInit() {
    this.insuranceVariantService.ensureAssignmentCached('details-me').subscribe({
      next: (assignment) => {
        const code = assignment?.version_code || 'optional';
        try { this.insuranceVariantService.preloadDetailsMeVariant(code); } catch {}
        this.loadVariantComponent(code);
      },
      error: () => this.loadVariantComponent('optional')
    });
  }

  private async loadVariantComponent(flowCode: string) {
    try {
      const module = await import('../mandatory/details-me/default/details-me');
      const component: Type<any> = module.DetailsME;
      this.variantContainer.clear();
      this.componentRef = this.variantContainer.createComponent(component);
      this.isLoading = false;
    } catch (error) {
      console.error(`Failed to load details-me variant for ${flowCode}:`, error);
      this.isLoading = false;
    }
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }
}
